<template>
  <div>
    <!-- 参与城市 -->
    <div class="session-cities-wrap">
      <!-- 在城市最外层绑定事件、倒三角按钮太小不方便触发 -->
      <div class="session-cities" @click.stop="toggleCities">
        <!-- 图标  -->
        <div class="session-cities-icon"></div>
        <!-- 图标  -->
        <!-- 城市列表 -->
        <div v-bind:class="{ 'session-cities-list-active': heightAuto,'is-overflow': !overHeight }" class="session-cities-list">

          <div class="session-cities-list-height">
            <!--参与城市：-->
            <!--<span :key="index" v-for="(city,index) of cities">-->
              <!--<template v-if="index!= (cities.length - 1)">-->
                <!--{{city.name ? city.name.replace(/市/g,"").replace(/辖区/g,""):''}}，-->
              <!--</template>-->
              <!--<template v-else>-->
                <!--{{city.name ? city.name.replace(/市/g,"").replace(/辖区/g,""):''}}-->
              <!--</template>-->
            <!--</span>-->
            竞拍保证金{{ frozenAmount | transformMoney }}元/辆，佣金{{ commissionAmount | transformMoney }}元/辆
          </div>
        </div>
        <!-- 城市列表 -->
        <!-- 图标  -->
        <!--<div class="session-cities-toggle">-->
          <!--<img :style="{ 'transform': `rotate(${degNum}deg)` }" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAABYklEQVRIS+2UQVLDMAxFJTX7cgO4AT1CuAGcoOmaSamb7in7OoZmWJMb0CNwhHADuAHZNxbjadJJ06TYmyyYZuexrCd9fQWhhw97YMAZ4qTyP5RLKXXFPLhEHORC3GdOetSClXodMRdDxOJbCPFlrvZySZksEeGxjJ/N5+GLK0jKdYCIb+YdMzxFUbg8gKxWyS0RvFeJmTmNounEFlQHmDdaw91iEW4OIObQDLQFxXHyDAAPtQInUTRNq/ORu4ymWusPRBju2uaUqBBCiJ+2ruI4McnGXYCjTqrAJggAMsTtTRNUBzBDzgxBJVG9oM49OQVSSl0we2Z+fjnknIj8LleeXEZja629DSJcl5VliDRh1sZBIxtAp1z1Vk3VWntmRhVof80Mn0QU/LVXVr+VNtAOsPW7DGE1k6aTyjkYq45dAFZyNWFSrmdERWrTQeee2G64S5zVTFwStsWeIU4K9iLXL2wmrRrAP9DhAAAAAElFTkSuQmCC" />-->
        <!--</div>-->
        <!-- 图标  -->
      </div>
      <!-- 在城市最外层绑定事件、倒三角按钮太小不方便触发 -->
    </div>
    <!-- 参与城市 -->
  </div>
</template>
<script>
export default {
  props: {
    frozenAmount: {
      type: Number,
      default: 0
    },
    commissionAmount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 超过多少行，省略号
      heightAuto: false,
      overHeight: false,
      // 旋转角度
      degNum: 0
    }
  },
  mounted() {
    this.isOverflow()
  },
  methods: {
    toggleCities() {
      // 切换显示场次城市列表，2行
      this.heightAuto = !this.heightAuto
      // this.degNum = this.degNum === 0 ? 180 : 0
    },
    isOverflow() {
      let cityDom = this.$el.querySelector('.session-cities-list')
      let cityDomStyle = document.defaultView.getComputedStyle(cityDom, null)
      let baseHeight = Number(cityDomStyle['height'].replace('px', ''))
      let paddingTop = Number(cityDomStyle['padding-top'].replace('px', ''))
      let paddingBottom = Number(cityDomStyle['padding-bottom'].replace('px', ''))
      let baseFullHeight = baseHeight + paddingTop + paddingBottom

      let cityHeightDom = this.$el.querySelector('.session-cities-list-height')
      let cityDomHeightStyle = document.defaultView.getComputedStyle(
        cityHeightDom,
        null
      )
      let realHeight = Number(cityDomHeightStyle['height'].replace('px', '')) + paddingTop
      this.overHeight = realHeight >= baseFullHeight
    }
  }
}
</script>

<style scoped lang="less">
@import '../../stylesheets/modules/components/city.less';
</style>
